var cilCommand = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M416,176a80,80,0,1,0-80-80v48H176V96a80,80,0,1,0-80,80h48V336H96a80,80,0,1,0,80,80V368H336v48a80,80,0,1,0,80-80H368V176ZM368,96a48,48,0,1,1,48,48H368ZM144,416a48,48,0,1,1-48-48h48Zm0-272H96a48,48,0,1,1,48-48ZM336,336H176V176H336Zm80,32a48,48,0,1,1-48,48V368Z' class='ci-primary'/>"];

export { cilCommand };
